export interface tarifInterface {
  name: string,
  title: string,
  price: string,
  from: string,
  explain: string,
  icon: string
}

export const tarif: Array<tarifInterface> = [
  {
    name: 'monthly',
    title: 'stripePlans.monthly.name',
    price: '1199',
    from: 'stripePlans.monthly.duration',
    explain: 'stripePlans.monthly.accroche',
    icon: 'assets/images/rate/mensuel.png',
  },
  {
    name: 'annual',
    title: 'stripePlans.yealy.name',
    price: '8999',
    from: 'stripePlans.yealy.duration',
    explain: 'stripePlans.yealy.accroche',
    icon: 'assets/images/rate/annuelle.png',
  },
  {
    name: 'app_lifetime',
    title: 'stripePlans.lifetime.name',
    price: '42900',
    from: 'stripePlans.lifetime.duration',
    explain: 'stripePlans.lifetime.accroche',
    icon: 'assets/images/rate/lifeTime.png',
  },
];
